import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { cancelCellEdit } from '../../actions/grid-screen';
import { updateRetargetingCommonPriceCell } from '../../actions/retargetingCommonPriceEditor';
import {
    PhraseContextMoneyCellEditorProps,
    PhraseContextMoneyEditor
} from '../../components/PhraseContextMoneyEditor/PhraseContextMoneyEditor';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellData } from '../../service/GridHelpers/GridHelpers';
import { ConstData } from '../../typings/constants';
import { CoverageByPriceData } from '../../typings/domain';
import { CurrencyCode } from '../../typings/graphql-grid';
import { State } from '../../typings/state';

export type StateProps = Pick<PhraseContextMoneyCellEditorProps, 'isSaving' | 'error' | 'priceLimit'>;

export interface DispatchProps {
    onSave: (value: number) => void;
    onCancel: () => void;
}

export type OwnProps = {
    id: string;
    cls?: string;
    cellName: string;
    currency: CurrencyCode;
    priceContext?: number;
    priceForCoverage: Array<CoverageByPriceData>;
    constants: ConstData;
    isCpmBanner: boolean;
};

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData } = state.grid;
    const { id, cellName, currency, constants } = ownProps;
    const { view } = selectGridSourceParams(state);
    const { minPrice, maxPrice, bigRate, minCpmPrice, maxCpmPrice } = constants.currencyConstants[currency];

    return {
        priceLimit: {
            minPrice,
            maxPrice,
            minCpmPrice,
            maxCpmPrice,
            bigRate
        },
        ...getEditCellData(editCellsData, id, cellName, view)
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { cellName, id } = ownProps;

    return {
        onSave: (value: number) => {
            dispatch(
                updateRetargetingCommonPriceCell(
                    {
                        id,
                        priceContext: value
                    },
                    cellName
                )
            );
        },
        onCancel: () => {
            dispatch(cancelCellEdit(id, cellName));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): PhraseContextMoneyCellEditorProps => {
    const { id, cellName, constants, ...prevProps } = ownProps;

    return {
        ...prevProps,
        ...stateProps,
        ...dispatchProps
    };
};

export const UsersProfileMoneyCellContextEditorContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PhraseContextMoneyCellEditorProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PhraseContextMoneyEditor);
